//------------------------------------------------------------------------------
// Node Modules ----------------------------------------------------------------
import React from 'react';
import classNames from 'classnames';
//------------------------------------------------------------------------------
// Style -----------------------------------------------------------------------
import styles from './index.module.scss';
//------------------------------------------------------------------------------
// My Components ---------------------------------------------------------------
import { Button, ButtonStyle, StateIndicator } from '@cmp/common';
import { Stripe as StripeIcon } from '@cmp/common/icons';
//------------------------------------------------------------------------------
// Helpers ---------------------------------------------------------------------
import { withAuthUser } from '@helpers/auth';
//------------------------------------------------------------------------------
// API -------------------------------------------------------------------------
import { createLoginLink } from '@api/endpoints/post/providers';

import { withTranslation } from 'react-i18next';
//------------------------------------------------------------------------------
// React Class -----------------------------------------------------------------
class PayoutButton extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loadingLink: false,
    };

    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    let that = this;
    const { __authUser } = this.props;

    this.setState({ loadingLink: true });

    createLoginLink(__authUser.email)
      .then(({ data }) => {
        if (!data) return;

        const { url } = data;
        window.open(url, '_blank').focus();
      })
      .finally(() => {
        that.setState({ loadingLink: false });
      });
  }

  render() {
    const { className, icon, t } = this.props;
    const { style } = this.props;
    const { loadingLink } = this.state;
    const componentClasses = classNames(styles.PayoutButton, {
      [className]: className,
    });

    return loadingLink ? (
      <div className={styles.StateIndicatorContainer}>
        <StateIndicator loading />
      </div>
    ) : (
      <Button
        className={componentClasses}
        style={style ? style : ButtonStyle.Primary}
        loading={loadingLink}
        onClick={this.onClick}
        iconComponent={
          icon ? (
            <img
              alt={t('accessibility_SearchProducts')}
              src={icon}
              className={styles.Icon}
            />
          ) : (
            <StripeIcon />
          )
        }
      >
        {t('profile_PayoutDetails')}
      </Button>
    );
  }
}
//------------------------------------------------------------------------------
// Export ----------------------------------------------------------------------
export default withAuthUser(withTranslation()(PayoutButton));
